<template>
    <div class="container d-flex flex-column align-items-center">
        <h2 class="text-white w-100 text-center">
            {{ confirmed ? $t('message.accountActivated') : $t('message.accountActivationFailed') }}
        </h2>

        <div v-if="confirmed" class="d-flex justify-content-between w-100 flex-wrap" style="white-space: pre-wrap">
            <h4 v-if="features.vkAuth" class="text-white mt-5 w-100 text-center col-12">{{ $tc('message.linkSocials', +features.vkAuth, { socials }) }}&nbsp;<router-link class="settings-button" to="/account">{{ $t('button.accountSettings') }}</router-link></h4>

            <h4 class="text-white my-5 w-100 text-center col-12">{{ $t('message.visitOtherApp') }}</h4>

            <div class="d-flex col-6 justify-content-center">
                <img :src="require('../assets/images/websitesIcons/mirera_icon.png')" width="36px" height="36px">

                <a class="ml-2" :href="mireraPath" style="font-size: 1.5rem; color: white;">{{ mireraName }}</a>
            </div>

            <div class="d-flex col-6 justify-content-center">
                <img :src="require('../assets/images/websitesIcons/piktomir_icon.png')" width="36px" height="36px">

                <a class="ml-2" :href="piktomirPath" style="font-size: 1.5rem; color: white;">{{ piktomirName }}</a>
            </div>
        </div>
    </div>
</template>

<script>
    import api from '@/api';
    import Paths from './mixins/Paths';
    import { USER_SET_STATUS } from 'mutations/user';
    import { mapGetters } from 'vuex';

    export default {
        name: 'ConfirmAccount',
        
        mixins: [ Paths ],

        data() {
            return {
                confirmed: true
            };
        },
        
        computed: {
            ...mapGetters([ 'features' ]),
            
            socials() {
                if (this.features.vkAuth)
                    return this.$t('message.vk');
                
                return null;
            }
        },

        async created() {
            if (this.$route.query.token) {
                let response = await api.post('/app/registration/confirm', {
                    token: this.$route.query.token
                });

                if (response && response.status === this.$defines.RESPONSE_STATUS.OK) {
                    this.confirmed = true;

                    this.$store.commit(`user/${USER_SET_STATUS}`, this.$defines.AUTHORIZE_STATUS.ACCOUNT_EXISTS);
                }
                else {
                    this.confirmed = false;
                }
            }
        }
    };
</script>

<style scoped>
    .settings-button {
        color: #FFFFFF;
        text-decoration: underline;
    }

    .settings-button:hover {
        cursor: pointer;
    }
</style>
